import { z } from "zod";

/** `GET /notifications/push/config` (push design FR-NT-057). Public values only. */
export const pushConfigSchema = z.object({
  enabled: z.boolean(),
  provider: z.string(),
  firebase: z
    .object({
      apiKey: z.string(),
      projectId: z.string(),
      messagingSenderId: z.string(),
      appId: z.string(),
    })
    .nullable(),
  vapidKey: z.string().nullable(),
});

/** `GET /notifications/push/subscriptions` rows: one of the caller's devices, never its token. */
export const pushDeviceSchema = z.object({
  id: z.string(),
  app: z.string(),
  deviceLabel: z.string().nullable(),
  createdAt: z.string(),
  lastSeenAt: z.string(),
  lastSuccessAt: z.string().nullable(),
});

/** `POST /notifications/push/subscriptions`. */
export const registeredDeviceSchema = z.object({ id: z.string(), created: z.boolean() });

/** `POST /notifications/push/test`. */
export const testPushSchema = z.object({ notificationId: z.string(), devices: z.number().int() });

export type PushConfig = z.infer<typeof pushConfigSchema>;
export type PushDevice = z.infer<typeof pushDeviceSchema>;
